// extracted by mini-css-extract-plugin
export default {"container":"NavSectionTitle_container__qewiP","active":"NavSectionTitle_active__Azfmv"};